@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.lists

import com.narbase.letsgo.dto.lists.ListItemDto
import com.narbase.letsgo.router.CrudEndPoint
import com.narbase.letsgo.router.EndPoint

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2024/02/01.
 */

abstract class GetListItemEndpoint :
        EndPoint<GetListItemEndpoint.Request, GetListItemEndpoint.Response>() {

    class Request(
            val pageNo: Int,
            val pageSize: Int,
            val searchTerm: String,
            val getHidden: Boolean
    )

    class Response(
            val list: Array<ListItemDto>,
            val total: Int
    )
}

abstract class ListItemCrudEndPoint : CrudEndPoint<ListItemDto, ListItemCrudEndPoint.Filter>() {
    data class Filter(
            var getHidden: Boolean? = false
    )
}